import { useEffect, useState } from "react";
import { DataGrid, ptBR } from "@mui/x-data-grid";
import { format, isValid, parseISO } from "date-fns";
import { toast } from "react-toastify";
import api from "../services/api";

const columns = [
    {
        field: "numero_reuniao",
        headerName: "Nº da reunião",
        width: 160,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
    },
    {
        field: "data_agendamento",
        headerName: "Data do agendamento",
        width: 200,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
    },
    {
        field: "data_reuniao",
        headerName: "Data da reunião",
        width: 180,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
    },
    {
        field: "projeto_cliente",
        headerName: "Projeto/Cliente",
        width: 280,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
    },
    {
        field: "assessor",
        headerName: "Assessor",
        width: 220,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
    },
    {
        field: "status_agendamento",
        headerName: "Status Agendamento",
        width: 200,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
    },
];

const statusAgendamento = {
    aguardando: "Aguardando",
    confirmado: "Confirmada",
    realizada: "Realizada",
    reagendada: "Reagendada",
    declinada: "Declinada",
    aguardando_nova_data: "Aguardando nova data",
    nao_aprovada: "Não aprovada",
    em_branco: "Em Branco",
};

function formatStatus(status) {
    if (!status) return "Em Branco";
    return statusAgendamento[status] || status;
}

function formatDate(value) {
    if (!value) return "";
    const parsed = parseISO(String(value));
    if (!isValid(parsed)) return "";
    return format(parsed, "dd/MM/yyyy");
}

function transformData(data) {
    if (!Array.isArray(data)) return [];

    return data.map((item) => ({
        id: item.id,
        numero_reuniao: item.id ?? "",
        data_agendamento: formatDate(item.data_agendamento_assessor || item.data_agendamento),
        data_reuniao: formatDate(item.data_reuniao),
        projeto_cliente: item.cliente?.name || item.customersName || "",
        assessor: item.assessor?.name || item.assessoresName || "",
        status_agendamento: formatStatus(item.status),
    }));
}

const HistoricoAgendamentos = ({ leadId }) => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!leadId || leadId === "null") {
            setRows([]);
            return;
        }

        let active = true;

        (async () => {
            try {
                setLoading(true);
                const result = await api.get(`/lead/${leadId}/agendas`);
                const data = result.data?.data || [];
                if (active) setRows(transformData(data));
            } catch (error) {
                if (active) {
                    toast.error("Não foi possível carregar o histórico de agendamentos");
                }
            } finally {
                if (active) setLoading(false);
            }
        })();

        return () => {
            active = false;
        };
    }, [leadId]);

    return (
        <div style={{ width: "100%", maxWidth: "100%", overflowX: "auto" }}>
            <h2>Histórico de Agendamentos</h2>
            <DataGrid
                autoHeight
                pagination
                rows={rows}
                columns={columns}
                pageSize={5}
                loading={loading}
                rowsPerPageOptions={[5]}
                disableSelectionOnClick
                localeText={ptBR.props.MuiDataGrid.localeText}
                style={{ width: "100%", height: "auto", flex: "none" }}
            />
        </div>
    );
};

export default HistoricoAgendamentos;
